export default {
  /**
   * @param {number | string | null} weight kg
   * @param {number | string | null} height m | cm
   * @returns {string | null}
   */
  imc(weight, height) {
    if (typeof weight === 'string') {
      weight = Number(weight)
    }
    if (typeof height === 'string') {
      height = Number(height)
    }

    if (!weight || Number.isNaN(weight) || !height || Number.isNaN(height)) {
      return null
    }

    if (height > 3) {
      height = height / 100
    }

    return (weight / height ** 2).toFixed(1)
  },
}
